import { Typography } from "@/components/essentials/typography";
import { ContractMenu, type ContractMenuItem } from "@/components/fragments/contract/contract-menu";
import { type FC } from "react";
import { labelContractFilterTestId, menuContractFilterTestId } from "./const";

export interface ContractFilterProps {
  readonly contract?: ContractMenuItem;
}

export const ContractFilter: FC<ContractFilterProps> = ({ contract }) => {
  return (
    <div>
      <Typography variant="display6" mb={2} data-testid={labelContractFilterTestId}>
        契約で絞り込む
      </Typography>
      <ContractMenu
        contractPlans={contract !== undefined ? [contract] : undefined}
        initialValue={contract}
        data-testid={menuContractFilterTestId}
      />
    </div>
  );
};
